<template>
  <div>
    <Subheader title="Set Your Goals" />

    <div class="app-content-column">
      <div class="card">
        <h5>Goal Information</h5>
        <p>Set up a few goals to help people understand why you're raising funds!</p>
        <p>
          One way to improve your chances of receiving funding is to break your project down into
          specific goals with funding needs attached. This is where you can list those goals. Try to
          be as specific as possible, thinking about practical steps that can be easily documented
          so you can show progress.
        </p>
        <p>
          We're collecting funds in U.S. dollars. Click
          <a
            href="https://www.xe.com/currencyconverter/convert/?Amount=1&From=KES&To=USD"
            target="_blank"
            >here</a
          >
          for a conversion calculator.
        </p>
      </div>

      <div v-for="(goal, key) in goals" :key="key">
        <EditGoalCard
          :goal="goal"
          :allow-remove="goals.length > 1"
          @remove-goal="removeGoal(key)"
        />
      </div>

      <div class="button-wrapper is-centered">
        <button class="medium-button" @click="addGoal">Add Another</button>
      </div>

      <div class="button-wrapper is-centered">
        <button type="submit" class="large-button" :disabled="loading" @click="submitGoals">
          Submit Goals
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'
import EditGoalCard from '@/components/EditGoalCard'
import Goal from '@/services/goals/models'

import { validateInputLength } from '@/services/forms'
import moment from 'moment'

export default {
  name: 'NewProjectGoals',
  components: {
    Subheader,
    EditGoalCard,
  },
  data() {
    return {
      loading: false,
      newMaker: false,
      goals: [],
      allGoalsFieldErrors: [],
    }
  },
  created() {
    if (this.$route.params.newMaker) {
      this.newMaker = true
    }
    this.addGoal()
  },
  methods: {
    submitGoals() {
      this.loading = true
      this.allGoalsFieldErrors = []

      this.goals.forEach(goal => {
        this.validateEach(goal)
      })

      if (this.allGoalsFieldErrors.length) {
        this.loading = false
      } else {
        // Post goals to API
        let goalPromises = []
        this.goals.forEach(goal => {
          // create a list of promises
          goalPromises.push(Goal.api.create(goal))
        })

        Promise.all(goalPromises).then(() => {
          if (this.newMaker) {
            // New Makers are routed to setup payouts at this point
            this.$router.push({
              name: 'PayoutSetup',
              params: { fromProjectGoalsPage: true, projectId: this.$route.params.projectId },
            })
          } else {
            // Otherwise, Makers are sent to review their project
            this.$router.push({
              name: 'Project',
              params: { projectId: this.$route.params.projectId },
            })
          }
        })
        this.loading = false
      }
    },
    addGoal() {
      const goalObj = {
        ...Goal.create(),
        project: this.$route.params.projectId,
        targetFunds: '',
        startDate: moment().format('YYYY-MM-DDTHH:mm'),
        fieldErrors: [],
      }
      this.goals.push(goalObj)
    },
    //TODO: splice is funky. Not removing selected goal
    removeGoal(key) {
      this.goals = [...this.goals.slice(0, key), ...this.goals.slice(key + 1)]
    },
    validateEach(goalObj) {
      goalObj.fieldErrors = []
      Object.keys(goalObj).forEach(field => {
        if (
          field === 'targetFunds' ||
          field === 'endDate' ||
          field === 'title' ||
          field === 'description'
        ) {
          const error = validateInputLength(field, goalObj[field])
          if (error) {
            goalObj.fieldErrors.push(error)
            this.allGoalsFieldErrors.push(error)
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/cards';
@import '../styles/mixins/buttons';
@import '../styles/forms';
@import '../styles/layout';

.card {
  @include card-w-borders();
}
</style>
